import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import classes from './UserActivityTableLayout.module.css';
import tableClasses from '../Table/Table/EventsTable.module.css'

import armed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/armed.png"
import disarmed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/disarmed.png"
import pulsed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/pulsed.png"
import locked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/locked.png"
import unlocked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked.png"
import otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/OTP.png"
import input_off from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_off.png"
import input_on from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_on.png"
import update from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/update.png"
import add from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/add.png"
import added from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/added.png"
import used_otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/used_otp.png"
import unlocked_unopened from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked_unopened.png"
import delete_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/delete_pin.png"
import deleted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/deleted.png"
import incorrect_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/incorrect_pin.png"
import linked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/linked.png"
import unlinked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlink.png"
import invited from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/invited.png"
import offline from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/offline.png"
import online from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/online.png"
import not_received from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/schedule_failed.png"
import accepted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/accepted.png"
import left from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/left.png"
import camect from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/camect.png"
import copy_users from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/copyUsers.png"
import override from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/override.png"
import warning from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/warning.png"
import changeRole from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/swap.png"
import gateway from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gateway.png"
import expired from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/time.png"
import Pill_Widget from '../UI/Widgets/Pill_Widget';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import BasicTable from './Table/Table';
import { serviceActions } from '../../store/service-Slice';
import { da } from 'date-fns/locale';
import useSetCookie from '../hooks/UseSetCookie';

const iconMapping = [
  armed, 
  disarmed, 
  pulsed, 
  locked, 
  unlocked, 
  otp,
  input_off, 
  input_on, 
  update, 
  add, 
  added, 
  used_otp,
  unlocked_unopened, 
  delete_pin, deleted, 
  incorrect_pin,
  linked, 
  unlinked, 
  invited, 
  offline, 
  online, 
  not_received,
  accepted, 
  left, 
  camect, 
  copy_users, 
  override, 
  warning,
  changeRole, 
  gateway, 
  expired
];

const getActivityText = (event) => {
  const { subType, eventData, type } = event;
  let recipientName = event.recipientName;
  if (recipientName === "Unknown") recipientName = "";

  switch (subType) {
    case 'removed': return recipientName + " " + subType;
    case 'added': return recipientName + " " + subType;
    case 'changeRole': return recipientName + "'s " + eventData;
    case 'suspended': return recipientName + " was " + eventData;
    case 'unsuspended': return recipientName + " was " + eventData;
    case "OPEN_CLOSE_LOCKED": return eventData + " relocked";
    case "OTP_UNLOCK": return eventData + " unlocked with OTP";
    case "PIN_UNLOCK":  return eventData;
    case "MASTER_PIN_UNLOCK":  return eventData + " unlocked with master PIN";
    case "UNOPENED_LOCKED": return eventData + " unlocked but not opened";
    case "INCORRECT_PIN": return "Incorrect PIN was attempted on " + eventData;
    case "Unlock": return eventData + " unlocked";
    case "DELETE_PIN": return "Pincode deleted from " + eventData;
    case "FIRST_DURATION_UNLOCK": return "Unlocked using Duration PIN";
    case "BLE_PIN_CREATED": return "BLE Pin created for " + eventData;
    case "expired": return recipientName + " - site access expired";
    default: return eventData;
  }
};

const m_names = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

function formatDate(date) {
  const day = date.getDate();
  const sup = [1, 21, 31].includes(day) ? "st"
    : [2, 22].includes(day) ? "nd"
    : [3, 23].includes(day) ? "rd" : "th";
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const h = hours % 12 || 12;
  const m = minutes < 10 ? '0' + minutes : minutes;
  return `${day}${sup} ${m_names[date.getMonth()]} ${date.getFullYear()}, ${h}:${m} ${ampm}`;
}

const UserActivityTableLayout = ({ data, isloading, groups }) => {

  console.log(data);

  const [pageSize, setPageSize] = useState(50)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const HandleGroupOnClick = (groupName) => {
    const groupClicked = groups.find(g => g.name === groupName);

    if (groupClicked) {
      sessionStorage.setItem('groupClicked', groupClicked.name)
      sessionStorage.setItem('groupPath', groupClicked.group_path)
      sessionStorage.setItem('groupClickedID', groupClicked.id)
      navigate("/Dashboard/Groups/GroupSites")
    }
  }

  const HandleUipiodOnClick = (DeviceUUID) => {
    dispatch(serviceActions.setDeviceUUID(DeviceUUID));
    useSetCookie("DeviceUUID", DeviceUUID, 1);
    navigate("/Dashboard/SiteView/" + DeviceUUID);

  }

    const [exportData, setExportData] = useState()
    const handleSetExportData = (data) => {
      setExportData(data);
      //if (setExportDataProp) setExportDataProp(data);
    }
  
    const exportFormatFunction = (event) => {
      return {
        Date: formatDate(new Date(event.eventDate)),
        Activity: getActivityText(event),
        User: event.user + (event.type == "rule" ? " via Super rule" : "")
      };
    };

  const tablecolumns = [
    {
      id: 'activity',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Activity</h3>
        </div>
      ),
      accessorKey: 'eventData',
      cell: (row) => {
        const subType = row.row.original.subType;
        const eventData = row.row.original.eventData;
        let recipientName = row.row.original.recipientName;
        if (recipientName == "Unknown"){
          recipientName = ""
        }
        const type = row.row.original.type

        const rowText = getActivityText(row.row.original);
        let iconPath;

        if (type === "Lock" || type === "IglooEvent"){
          if (subType === "Unlock"){
            iconPath = iconMapping[4]
          } else if (subType === "OPEN_CLOSE_LOCKED") {
            iconPath = iconMapping[3]
          } else if (subType === "OTP" || subType === "BLE_PIN_CREATED"){
            iconPath = iconMapping[5]
          } else if (subType === "OTP_UNLOCK" || subType === "PIN_UNLOCK" || subType === "FIRST_DURATION_UNLOCK" || subType === "FIRST_PERMANENT_UNLOCK"){
            iconPath = iconMapping[11]
          } else if (subType === "UNOPENED_LOCKED"){
            iconPath = iconMapping[12]
          } else if (subType === "DELETE_PIN"){
            iconPath = iconMapping[13]
          } else if (subType === "INCORRECT_PIN"){
            iconPath = iconMapping[15]
          } else if (subType === "LINK"){
            iconPath = iconMapping[16]
          } else if (subType === "UNLINK"){
            iconPath = iconMapping[17]
          }
        } else if (type === "Input") {
          if (subType === "Armed"){
            iconPath = iconMapping[7]
          } else {
            iconPath = iconMapping[6]
          }
        } else if (type === "output" || type == "rule") {
          if (subType === "Armed"){
            iconPath = iconMapping[0]
          } else if (subType === "Disarmed"){
            iconPath = iconMapping[1]
          } else {
            iconPath = iconMapping[2]
          }
        } else if (type === "EfentoStatus"){
          iconPath = iconMapping[27]
        } else if (subType === "update" || subType === "Link" || subType === "Update"){
          iconPath = iconMapping[8]
        } else if (subType === "add" || subType === "Set" || subType === "Add" || subType === "Added" || subType === "Linked"){
          iconPath = iconMapping[9]
        } else if (subType === "added" ){
          iconPath = iconMapping[10]
        } else if (subType === "delete" || subType === "removed" || subType === "Delete"){
          iconPath = iconMapping[14]
        } else if (subType === "LINK"){
          iconPath = iconMapping[16]
        } else if (subType === "invited"){
          iconPath = iconMapping[18]
        } else if (subType === "offline"){
          iconPath = iconMapping[19]
        } else if (subType === "online"){
          iconPath = iconMapping[20]
        } else if (type === "ScheduledAction"){
          iconPath = iconMapping[21]
        } else if (subType === "accepted"){
          iconPath = iconMapping[22]
        } else if (subType === "left"){
          iconPath = iconMapping[23]
        } else if (type === "Camect"){
          iconPath = iconMapping[24]
        } else if (subType === "copyDeviceUsers"){
          iconPath = iconMapping[25]
        } else if (subType === "Override"){
          iconPath = iconMapping[26]
        } else if (eventData === "Logs cleared"){
          iconPath = iconMapping[14]
        } else if (subType === "Unlinked"){
          iconPath = iconMapping[14]
        } else if (subType === "changeRole"){
          iconPath = iconMapping[28]
        } else if (subType == "suspended" || subType == "unsuspended"){
          iconPath = iconMapping[27]
        } else if (type == "gateway"){
          if (subType == "tamper"){
            iconPath = iconMapping[27]
          } else {
            iconPath = iconMapping[29]
          }

        } else if (type == "SiteAccess"){
          iconPath = iconMapping[30]
        }

        console.log("[UserActivity] type:", type, "subType:", subType, "iconPath:", iconPath);

        return (
            <div  style={{ display: "flex",  alignItems: "center", gap: "10px" }}>
              <div />
              {iconPath && <img className={classes.img} src={iconPath}/>}
             <div className={classes.tableValueText}>
              {rowText}
              </div>
            </div>
        )
      }
    },
    {
      id: 'time',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Time</h3>
        </div>
      ),
      accessorKey: 'eventDate',
      cell: (row) => {
        const eventDate = new Date(row.row.original.eventDate)
        return (
          <div className={classes.tableValueText}>
            {formatDate(eventDate)}
          </div>)
      }
    },
        {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3 style={{ marginLeft: "20px" }}>Portal name</h3>
        </div>
      ),
      filterLabel: "Site name",
      accessorKey: 'tag',
      cell: (row) => {
        const uuid = row.row.original.uuid;
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2
          }}>
            <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: "pointer", width: "fit-content" }}>
                {row.row.original.tag && row.row.original.tag.trim() !== "" && (
                  <Pill_Widget
                    boolean={true}
                    PillColor_IfTrue={"#919191"}
                    PillColor_IfFalse={"#6e6e6e"}
                    text_IfTrue={row.row.original.tag}
                    className={classes.PillHeight}
                  />
                )}
              </div>
          </div>

        );
      },
    },
      {
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Site ID</h3>
        </div>
      ),
      filterLabel: "Site ID",
      accessorKey: 'key',
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const key = row.row.original.key;
        return (
          <Link
            onClick={() => HandleUipiodOnClick(uuid)}
            to={`/Dashboard/SiteView/${uuid}`}
            className={classes.tableValueTextBold}
          >
            {key}
          </Link>
        )
      }
    },
       {
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      filterLabel: "Group",
      accessorKey: 'name',
      cell: (row) => {
        let companyName = row.row.original.name;

        if (companyName == "RE:SURE") {
          companyName = "RESURE"
        }

        const companyColors = {
          EyeSpyFX: "rgb(100, 149, 237)",
          RESURE: "rgb(75, 0, 130)",
          PARFAS: "rgb(0, 0, 0)",
          PORTAL_SECURITY: "rgb(0, 0, 139)",
          SOLO: "rgb(178, 34, 34)",
          KNOWIO: "rgb(20, 155, 8)",
          CPS: "rgb(8, 155, 121)",
          CSC_SECURITY: "rgb(8, 150, 155)",
          EES: "rgb(94, 8, 155)"
        };

        const companyColor = companyColors[companyName] || "#6e6e6e";

        return (

          <div style={{
            maxWidth: '200px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: "pointer", color: "white", fontWeight: "600"
          }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={companyColor}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.name}
              className={classes.PillHeight}
            />
          </div>
        )

      }
    },
  ];

  return (
    // <DataTable
    //   value={data}
    //   loading={isloading}
    //   paginator
    //   rows={rows}
    //   rowsPerPageOptions={[10, 50, 100]}
    //   onPage={(e) => setRows(e.rows)}
    //   sortField="eventDate"
    //   sortOrder={-1}
    //   stripedRows
    //   emptyMessage="No activity found for the selected period."
    //   className={classes.table}
    //   pt={{
    //     root: { style: { borderRadius: '8px', overflow: 'hidden' } },
    //     header: { style: { borderBottom: '1px solid #e5e7eb' } },
    //   }}
    // >
    //   <Column header="Activity" body={activityBody} sortable sortField="eventData" style={{ minWidth: '260px' }} />
    //   <Column header="Time" field="eventDate" body={timeBody} sortable style={{ minWidth: '200px' }} />
    //   <Column header="Site ID" field="key" body={siteBody} sortable style={{ minWidth: '140px' }} />
    //   <Column header="Group" field="name" body={siteOwnerBody} sortable style={{ minWidth: '200px' }} />

    // </DataTable>

    <div className={classes.table}>
      <div className={classes["tableCardLayoutUI-wrapper"]}>
        <div className={classes["top-wrapper"]}>
          {/* <div className={classes["info-bar"]}>
            <>
               {isloading && <ThreeDots stroke="var(--Primary-Color)" height={50} width={25} speed={1.5} />}
            </>
           </div>  */}
        </div>
        {isloading ? (
            <div className={classes["skeleton-list"]}>
              {[...Array(10)].map((_, i) => (
                <div key={i} className={classes["skeleton-row"]}>
                  <div className={classes["skeleton-activity"]}>
                    <div className={classes["skeleton-circle"]} />
                    <div className={classes["skeleton-bar"]} style={{ height: "16px", width: `${120 + (i % 4) * 40}px` }} />
                  </div>
                  <div className={classes["skeleton-time"]}>
                    <div className={classes["skeleton-bar"]} style={{ height: "16px", width: "140px" }} />
                  </div>
                  <div className={classes["skeleton-user"]}>
                    <div className={classes["skeleton-bar"]} style={{ height: "16px", width: `${80 + (i % 3) * 30}px` }} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <BasicTable 
              data={data} 
              columns={tablecolumns} 
              filtering={""} 
              rowClick={false} 
              ShowPagination={true} 
              PageSize={pageSize} 
              setPageSize={setPageSize} 
              paginationOptions={[10, 50, 100]} 
              tableClasses={tableClasses} 
              setExportData={handleSetExportData} 
              exportFormatFunction={exportFormatFunction} 
            />
          )}
      </div>
    </div>
  );
};

export default UserActivityTableLayout;
